(function () {
    'use strict';

    angular
        .module('EventListApp')
        .controller('ExhibitorCtrl', exhibitorCtrl);

    exhibitorCtrl.$inject = ['$timeout', '$filter', 'ApiFactory', '$translation', '$interval', 'SpinnerService'];

    function exhibitorCtrl($timeout, $filter, ApiFactory, $translation, $interval, SpinnerService) {
        var vm = this;
        var utmParams = ['utm_source', 'utm_medium', 'utm_campaign'];
        var webID = 0;
        var connect = new connectModel();
        vm.exhibitorID = 0;
        vm.showSlots = [];
        vm.form = { email: '', code: '' };
        vm.isLoading = false;
        vm.maskedMail = '';
        var currentStep = 0;
        var calander = { name: '', start: 0, end: 0, description: '', location: '', title: '' };
        var codeSentTime = new Date();
        var codeRtryLimit = 20;
        var isCodeValid = false;

        vm.initExhibitor = function (eventID, lang, eventSecret, exhibitorID) {
            ApiFactory.SetToken(eventSecret);
            setClientCookie();

            vm.eventID = eventID;
            vm.lang = lang;
            vm.exhibitorID = exhibitorID;
            vm.eventCode = eventSecret;

            if (typeof getWebID == 'function')
                webID = getWebID();


            if (typeof Ea_eventact == 'function')
                Ea_eventact(eventID, false, '', lang, webID, 6);
            getSubExhibitors(exhibitorID);
        }

        vm.initConnect = function (eventID, lang, eventSecret, exhibitorID, contactID) {
            ApiFactory.SetToken(eventSecret);
            setClientCookie();
            vm.eventID = eventID;
            vm.lang = lang;
            vm.exhibitorID = exhibitorID;
            vm.eventCode = eventSecret;
            // page globals set by ConnectExhibitor.cshtml; bound via vm so user text is never parsed as an Angular expression
            vm.exhibitorName = exhibitorName;
            vm.staffName = staffName;
            vm.eventTitle = eventTitle;

            SpinnerService.Show('connectSpinner');
            connect.ProjectID = eventID;
            connect.PublicKey = eventSecret;
            connect.Exhibitor = exhibitorID;
            connect.ToParticipant = contactID;

            if (typeof getWebID == 'function')
                webID = getWebID();

            if (typeof Ea_eventact == 'function')
                Ea_eventact(eventID, false, '', lang, webID, 6);
            checkNextStep(currentStep);
        }

        vm.setTimeSlot = function (day, timeslot) {
            connect.TimeSlot = timeslot.slotID;
            vm.selectedTime = timeslot.time;
            calander.start = parseInt(timeslot.fullDate);
            calander.end = moment.utc(parseInt(timeslot.fullDate)).add(20, 'm')._d.getTime();
            calander.location = vm.timeSlots.PlaceName;
            calander.title = $translation.translate('meetingWith', [staffName]);
            var params = [staffName];
            if (connect.ToParticipant > 0)
                params.push(org);

            var msg = connect.ToParticipant > 0 ? "participantMeetingDescription" : "exhibitorMeetingDescription";
            calander.description = $translation.translate(msg, [org, staffName]);

            vm.cal = calander;
            vm.selectedDay = day;
            if (!vm.timeSlots.ShowMessage)
                ++currentStep;

            checkNextStep(++currentStep);
        }

        vm.checkMail = function () {
            vm.isLoading = true;
            var request = new userVerification(connect.ProjectID, connect.PublicKey, vm.form.email);

            // m***k@mail.com
            vm.maskedMail = vm.form.email.replace(/^(.)(.*)(.@.*)$/,
                (_, a, b, c) => a + b.replace(/./g, '*') + c
            );

            ApiFactory.CheckLogin(request).then(function (response) {
                vm.isLoading = false;
                if (!response || !response.data) {
                    requestError(response);
                    return;
                }
                /**@type{{result:boolean,errorMsg:string,exceededAttempts:boolean,userCode}} */
                var data = response.data;
                if (data.exceededAttempts) {
                    vm.errorMsg = $translation.translate(data.errorMsg, [data.timeLeft]);
                    checkNextStep(-1);
                }

                vm.mailError = data.errorMsg;
                resetVerificationCodeRetry();
                if (data.result == false)
                    return;

                checkNextStep(++currentStep)
            }).catch(requestError);
        }

        vm.resendCode = function () {
            var remainTime = getTimeDiff(codeSentTime, new Date(), 'seconds');
            if (remainTime < codeRtryLimit - 2) {
                vm.codeError = 'Please wait ' + (codeRtryLimit - remainTime) + ' seconds';
                return;
            }

            var request = new userVerification(connect.ProjectID, connect.PublicKey, vm.form.email);
            vm.isLoading = true;
            ApiFactory.CheckLogin(request).then(function (response) {
                vm.isLoading = false;
                if (!response || !response.data) {
                    requestError(response);
                    return;
                }

                /**@type{{result:boolean,errorMsg:string,exceededAttempts:boolean,userCode,timeLeft:number}} */
                var data = response.data;
                vm.codeError = data.errorMsg;
                if (data.exceededAttempts) {
                    vm.errorMsg = $translation.translate(data.errorMsg, [data.timeLeft]);
                    checkNextStep(-1);
                    return;
                }

                if (data.result == false)
                    return;

                resetVerificationCodeRetry();
            }).catch(requestError);
        }

        // todo: use interval to show remaining time 
        function resetVerificationCodeRetry() {
            codeSentTime = new Date();
            vm.canResendCode = false;
            vm.remainingTime = codeRtryLimit;
            var i = 0;
            var timeInterval = $interval(function () {
                i++;
                vm.remainingTime = codeRtryLimit - i;
                if (i >= codeRtryLimit) {
                    $interval.cancel(timeInterval);
                    vm.remainingTime = 0;
                    vm.canResendCode = true;
                }
            }, 1000);
        }

        //to do: verify & connect?
        // or connect?
        vm.verifyCode = function () {
            if (!vm.form.code || isNaN(vm.form.code)) {
                vm.codeError = isNaN(vm.form.code) ? 'wrongOtp' : 'codeRequired';
                return;
            }

            var request = new userVerification(connect.ProjectID, connect.PublicKey, vm.form.email);
            request.code = vm.form.code;
            vm.isLoading = true;
            ApiFactory.VerifyCode(request).then(function (response) {
                vm.isLoading = false;
                if (!response || !response.data) {
                    requestError(response);
                    return;
                }

                /**@type{{result:boolean,errorMsg:string,exceededAttempts:boolean,userCode:string}} */
                var data = response.data;
                vm.codeError = data.errorMsg;
                if (data.exceededAttempts) {
                    vm.errorMsg = $translation.translate(data.errorMsg, [data.timeLeft]);
                    checkNextStep(-1);
                }

                if (data.result == false)
                    return;

                connect.ParticipantCode = data.userCode;
                checkNextStep(++currentStep);
            }).catch(requestError);
        }

        vm.connectParticipant = function () {
            connect.Message = vm.form.message || '';
            checkNextStep(++currentStep)
        }
        /**
         * @param {number} step
         */
        function checkNextStep(step) {
            vm.showTimeSlots = vm.showMessage = vm.showCode = vm.showMail = false;
            switch (step) {
                case 0:
                    getTimeSlots();
                    break;

                case 1:
                    vm.showMessage = true;
                    break;

                case 2:
                    if (!connect.ParticipantCode)
                        vm.showMail = true;
                    else
                        checkNextStep(++currentStep);
                    break;

                case 3:
                    if (!connect.ParticipantCode)
                        vm.showCode = true;
                    else
                        checkNextStep(++currentStep);

                    break;

                case 4:
                    connectParticipant();
                    break;

                default:
                    break;
            }
        }

        function requestError(err) {
            vm.isLoading = false;
            console.log(err);
            alert('An error occurred');
        }

        function getTimeSlots() {
            vm.isLoading = true;
            ApiFactory.GetExhibitorTimeslots(connect.ProjectID, connect.PublicKey, connect.Exhibitor, (connect.ToParticipant || 0))
                .then(function (response) {
                    vm.isLoading = false;
                    if (!response || !response.data) {
                        requestError('No data');
                        return;
                    }

                    var data = response.data;
                    vm.timeSlots = data;
                    var slots = data.TimeSlots;
                    vm.errorMsg = data.ErrorMsg
                    vm.slotsPerDay = $filter('slotsGroupByDay')(slots);
                    if (!slots.length) {
                        if (!vm.errorMsg)
                            vm.errorMsg = 'noTimes';
                    }
                    else
                        vm.showTimeSlots = true;

                }).catch(requestError);
        }

        function getSubExhibitors(exhibitorID) {
            ApiFactory.GetAllExhibitors(vm.eventID, vm.lang).then(function (response) {
                vm.subExhibitors = [];
                var exhibitors = response.data;
                exhibitors.forEach(function (ex, idx) {
                    if (ex.participantID != exhibitorID
                        && ex.mainExhibitorID == exhibitorID)
                        vm.subExhibitors.push(ex);
                })
            });
        }

        function setClientCookie() {
            var vars = {};
            window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
                vars[key] = value;
            });

            var utmParam = ''
            for (var i = 0; i < utmParams.length; i++) {
                utmParam = utmParams[i];
                if (vars.hasOwnProperty(utmParam))
                    setCookie('eventlist_' + utmParam, vars[utmParam], null); // null = cookie duration = session
            }
        }

        function connectParticipant() {
            vm.isLoading = true;
            if (!connect.TimeSlot) {
                vm.errorMsg = "selectTime";
                vm.showSlots = true;
                return;
            }

            vm.errorMsg = "";
            ApiFactory.ScheduleMeeting(connect).then(function (response) {
                vm.isLoading = false;

                if (!response || !response.data) {
                    requestError(response);
                    return;
                }

                var { msg, result } = response.data;
                if (!result) {
                    currentStep = 0;
                    vm.errorMsg = msg;
                    vm.showTimeSlots = true;
                    vm.showMessage = vm.showCode = vm.showMail = false;
                    $timeout(function () {
                        $('html, body').animate({
                            scrollTop: $(".error-msg").offset().top - 150
                        }, 1000);
                    }, 500)
                }
                else {
                    vm.successMsg = msg;
                    vm.meetingResult = true;
                    vm.calander = calander;
                }


            }).catch(requestError);
        }

        /**
         * @param {Date} startDate
         * @param {Date} endDate
         * @param {string} [timePart]
         */
        function getTimeDiff(startDate, endDate, timePart) {
            var msInSecond = 1000;
            return Math.round((endDate.getTime() - startDate.getTime()) / msInSecond);
        }
    }

    function userVerification(projectID, publicKey, email) {
        this.projectID = projectID;
        this.publicKey = publicKey;
        this.email = email;
        this.code = 0;
    }

    function connectModel() {
        this.ProjectID = 0;
        this.PublicKey = '';
        this.TimeSlot = 0;
        this.SelectedDate = '';
        this.TimeSlot = 0;
        this.ToParticipant = 0;
        this.Exhibitor = 0;
        this.ParticipantCode = '';
        this.Message = '';
        this.Email = '';
        this.Code = '';
    }

})();
